import { Injectable } from '@angular/core';
import { StorageService } from '@shared/core';
import { EMPTY, Observable } from 'rxjs';

const AUTH_TOKEN = 'authToken';
const USER_INFO_TOKEN = 'userInfoToken';
const REFRESH_TOKEN = 'refreshToken';

@Injectable({
  providedIn: 'root',
})
export class DataStorageService extends StorageService {
  logout(): void {
    this.remove(AUTH_TOKEN);
    this.remove(USER_INFO_TOKEN);
    this.remove(REFRESH_TOKEN);
  }

  setUserData(data: unknown): void {
    this.set(USER_INFO_TOKEN, data);
  }

  clearUserData(): void {
    this.remove(USER_INFO_TOKEN);
  }

  getUserData<T>(): T | undefined {
    return this.get<T>(USER_INFO_TOKEN);
  }

  onUserDataChanged<T>(): Observable<T | null> {
    return this.watch<T>(USER_INFO_TOKEN) ?? EMPTY;
  }

  setToken(token: string | undefined): void {
    this.set(AUTH_TOKEN, token);
  }

  setTokens(accessToken: string | undefined, refreshToken: string | undefined): void {
    this.set(AUTH_TOKEN, accessToken);
    this.set(REFRESH_TOKEN, refreshToken);
  }

  getRefreshToken(): string | undefined {
    return this.get<string>(REFRESH_TOKEN);
  }

  getToken(): string | undefined {
    return this.get<string>(AUTH_TOKEN);
  }

  onTokenChanged(): Observable<string | null> {
    return this.watch(AUTH_TOKEN) ?? EMPTY;
  }
}
